import { parseTime } from "../modules/shared/helpers/time";

const ordenesDeServicioStore = {
  namespaced: true,
  state: () => ({
    list: [],
    servicios: [],
    vehiculos: [],
    guias: [],
    asistentes: [],
    conductores: [],
    serviciosFiltro: [],
    idiomasFiltro: [],
  }),
  mutations: {
    loadContainers(state, { servicios, vehiculos, guias, asistentes, conductores, serviciosFiltro, idiomasFiltro }) {
      state.servicios = servicios;
      state.vehiculos = vehiculos;
      state.guias = guias;
      state.asistentes = asistentes;
      state.conductores = conductores;
      state.serviciosFiltro = serviciosFiltro;
      state.idiomasFiltro = idiomasFiltro;
    },
    updateList(state, list) {
      state.list = list;
    },
  },
  getters: {
    hayEditables(state) {
      return !!state.list.some((item) => item.isNew || item.isEdit);
    },
  },
  actions: {
    newItem({ commit, state }) {
      const newList = [...state.list];

      newList.unshift({
        idOrden: new Date().getTime(),
        isNew: true,
        isEdit: false,
        tempFecha: "",
        tempServicio: null,
        tempHoraSalida: "",
        tempVehiculo: null,
        tempConductor: null,
        tempOtroConductor: "",
        tempContacto: "",
        tempGuia: null,
        tempAsistente: null,
        tempTransfer: "",
        tempObservacion: "",
        tempAwanacancha: false,
      });

      commit("updateList", newList);
    },
    editItem({ commit, state }, id) {
      const newList = state.list.map((item) => {
        if (item.idOrden == id) {
          return {
            ...item,
            isEdit: true,
            tempFecha: item.fecha,
            tempServicio: state.servicios.find((servicio) => servicio.idServicio == item.idServicio),
            tempHoraSalida: item.horaSalida
              ? item.horaSalida
                  .split(":")
                  .slice(0, 2)
                  .join(":")
              : "",
            tempVehiculo: state.vehiculos.find((vehiculo) => vehiculo.idVehiculo == item.idVehiculo),
            tempConductor: item.idConductor ? state.conductores.find((conductor) => conductor.idPersona == item.idConductor) : null,
            tempOtroConductor: item.otroConductor || "",
            tempContacto: item.contactoConductor || "",
            tempGuia: state.guias.find((guia) => guia.idPersona == item.idGuia),
            tempAsistente: item.idAsistente ? state.asistentes.find((asistente) => asistente.idPersona == item.idAsistente) : null,
            tempTransfer: item.transfer || "",
            tempObservacion: item.observacion || "",
            tempAwanacancha: item.awanacancha == "No" ? false : true,
          };
        }
        return item;
      });

      commit("updateList", newList);
    },
    removeItem({ commit, state }, id) {
      const newList = state.list.filter((item) => item.idOrden != id);
      commit("updateList", newList);
    },
    saveItem({ commit, state }, { id, newId, newCodigo }) {
      const newList = state.list.map((item) => {
        if (item.idOrden == id) {
          return {
            ...item,
            isNew: false,
            isEdit: false,
            idOrden: newId,
            codigo: newCodigo,
            fecha: item.tempFecha,
            servicio: item.tempServicio.nombre,
            idServicio: item.tempServicio.idServicio,
            horaSalida: item.tempHoraSalida ? parseTime(item.tempHoraSalida) + ":00" : "",
            idVehiculo: item.tempVehiculo.idVehiculo,
            vehiculo: item.tempVehiculo.vehiculo,
            conductor: item.tempConductor?.nombreCompleto || "",
            idConductor: item.tempConductor?.idPersona || "",
            otroConductor: item.tempOtroConductor || "",
            contactoConductor: item.tempContacto || "",
            guia: item.tempGuia?.nombre || "",
            idGuia: item.tempGuia?.idPersona || "",
            asistente: item.tempAsistente?.nombre || "",
            idAsistente: item.tempAsistente?.idPersona || "",
            transfer: item.tempTransfer || "",
            observacion: item.tempObservacion || "",
            awanacancha: item.tempAwanacancha ? "Sí" : "No",
          };
        }
        return item;
      });

      commit("updateList", newList);
    },
  },
};

export default ordenesDeServicioStore;
